import adminSchemasLoader from '@/mixins/fetcher/loaders/admin/schemas-loader';
import ormHelpers from '@/mixins/admin/helpers/orm-helpers';

export default {

  data() {
    return {
      debug: this.$store.get('debug/orm@debug'),
      showCount: this.$store.get('debug/orm@showCount'),
    };
  },

  mixins: [
    adminSchemasLoader,

    ormHelpers,
  ],

  methods: {
    async loadFetcherAdminCache(fromDb) {
      if (this.$auth.check()) {
        const promises = [];

        /* ORM */
        // this.loadData('FeedRule', fromDb);
        // this.loadData('Feed', fromDb);
        // this.loadData('Job', fromDb);
        // this.loadData('List', fromDb);
        // this.loadData('Network', fromDb);
        // this.loadData('Profile', fromDb);
        // this.loadData('WikipediaPage', fromDb);

        promises.push(this.loadData('Feed', fromDb));
        promises.push(this.loadData('FeedRule', fromDb));
        promises.push(this.loadData('Job', fromDb));
        promises.push(this.loadData('List', fromDb));
        promises.push(this.loadData('Network', fromDb));
        promises.push(this.loadData('Profile', fromDb));
        promises.push(this.loadData('WikipediaPage', fromDb));

        /* ORM */
        /* DB */
        promises.push(this.loadFetcherAdminSchema('forms'));
        /* DB */

        await Promise.all(promises);
      }
    },

    async loadData(model, fromDb) {
      const ormEntity = this.getOrmEntity(model);

      if (this.debug) { console.log(`${model} requested!`); }

      if (ormEntity.all().length === 0 || fromDb) {
        await this.fetchData(model);
      } else {
        if (this.debug) { console.log(`${model} already fetched!`); }

        this.dataLoaded(model);
      }
    },

    async fetchData(model) {
      const ormEntity = this.getOrmEntity(model);

      if (this.debug) { console.log(`fetching ${model}...`); }

      // const fetchParams = {
      //   query: {
      //     // token: this.$auth.token(),
      //     // limit: 100,
      //     // l: 'list',
      //   },
      // };

      const fetchParams = {};

      await ormEntity.$fetch(fetchParams);

      if (this.debug) { console.log(`${model} fetched!`); }

      this.dataLoaded(model);
    },

    dataLoaded(model) {
      const ormEntity = this.getOrmEntity(model);

      if (this.debug) { console.log(`${model}-loader.${model}`, ormEntity.all()); }
      if (this.showCount) { console.log(`${model}-loader.${model}.count`, ormEntity.query().count()); }
    },
  },

  mounted() {
    this.loadFetcherAdminCache(false);

    Bus.$on('refresh_cache_admin', () => {
      this.loadFetcherAdminCache(true);
    });
  },

  beforeDestroy() {
    Bus.$off('refresh_cache_admin');
  },
};
